// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36JO-","question":"styles_question__2EGrC","description":"styles_description__ng0DW"};